import Vue from 'vue'
import { getLocale } from '@/utils/locale'
import { store } from '@/store'

Vue.prototype.$removeValueArray = function(data_array) {
  var what = arguments
  var a = arguments
  var L = a.length
  var ax
  while (L && data_array.length) {
    what = a[--L]
    while ((ax = data_array.indexOf(what)) !== -1) {
      data_array.splice(ax, 1)
    }
  }
  return data_array
}
Vue.prototype.$isEmpty = function(obj) {
  for (var key in obj) {
    if (obj.hasOwnProperty(key)) {
      return false
    }
  }
  return true
}
Vue.prototype.$sumArray = function(array) {
  var sum = 0
  for (var el in array) {
    if (array.hasOwnProperty(el)) {
      sum += parseFloat(array[el])
    }
  }
  return sum
}
Vue.prototype.$curDistance = function(lat1, lon1, lat2, lon2) {
  if ((lat1 === lat2) && (lon1 === lon2)) {
    return 0
  } else {
    var radlat1 = Math.PI * lat1 / 180
    var radlat2 = Math.PI * lat2 / 180
    var theta = lon1 - lon2
    var radtheta = Math.PI * theta / 180
    var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta)
    if (dist > 1) {
      dist = 1
    }
    dist = Math.acos(dist)
    dist = dist * 180 / Math.PI
    dist = dist * 60 * 1.1515
    dist = dist * 1.609344
    var curDistance = Math.round(dist * 1000)
    return curDistance
  }
}
Vue.prototype.$getObjectArray = function(array, field_obj, field, data = null) {
  if (data) {
    const object = array.find(obj => {
      return obj[field_obj] === field
    })
    if (object === undefined) {
      return array[0][data]
    } else {
      return object[data]
    }
  } else {
    return array.find(obj => {
      return obj[field_obj] === field
    })
  }
}
Vue.prototype.$stockCart = function(id, _storage = '_v2_cart', type = 'product', isEdit = false, idx = 0) {
  var qty = 0
  var cart = {
    item: []
  }
  const LOCAL_DATA_CART = localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + _storage)
  if (LOCAL_DATA_CART) {
    cart = JSON.parse(LOCAL_DATA_CART)
  }
  if (typeof cart.item !== 'undefined' && cart.item.length > 0) {
    for (var i = 0; i < cart.item.length; i++) {
      if (type === 'variant') {
        if (cart.item[i].product_variant_id && Number(cart.item[i].product_variant_id) === Number(id)) {
          qty = qty + (isEdit ? idx === i ? 0 : Number(cart.item[i].qty) : Number(cart.item[i].qty))
        }
        if (cart.item[i].product_combo_id) {
          for (var y = 0; y < cart.item[i].product_combo_items.length; y++) {
            if (cart.item[i].product_combo_items[y].variant_id && Number(cart.item[i].product_combo_items[y].variant_id) === Number(id)) {
              qty = qty + ((isEdit ? idx === i ? 0 : Number(cart.item[i].qty) : Number(cart.item[i].qty)) * Number(cart.item[i].product_combo_items[y].qty))
            }
          }
        }
        if (cart.item[i].materials.length > 0) {
          for (let c = 0; c < cart.item[i].materials.length; c++) {
            const material = cart.item[i].materials[c]
            if (material.material_product_variant_id && Number(material.material_product_variant_id) === Number(id)) {
              qty = qty + (isEdit ? idx === i ? 0 : Number(material.qty_in_cart) : Number(material.qty_in_cart))
            }
          }
        }
        if (cart.item[i].addons.length > 0) {
          for (let x = 0; x < cart.item[i].addons.length; x++) {
            const item_addons = cart.item[i].addons[x]
            if (item_addons.product_addon_variant_id && Number(item_addons.product_addon_variant_id) === Number(id)) {
              // qty = qty + (Number(item_addons.product_addon_qty) * Number(cart.item[i].qty))
              qty = qty + ((isEdit ? idx === i ? 0 : Number(cart.item[i].qty) : Number(cart.item[i].qty)) * Number(item_addons.product_addon_qty))
            }
          }
        }
      } else {
        if (cart.item[i].product_id && Number(cart.item[i].product_id) === Number(id)) {
          qty = qty + (isEdit ? idx === i ? 0 : Number(cart.item[i].qty) : Number(cart.item[i].qty))
        }
        if (cart.item[i].product_combo_id) {
          for (var z = 0; z < cart.item[i].product_combo_items.length; z++) {
            if (cart.item[i].product_combo_items[z].id && Number(cart.item[i].product_combo_items[z].id) === Number(id)) {
              qty = qty + ((isEdit ? idx === i ? 0 : Number(cart.item[i].qty) : Number(cart.item[i].qty)) * Number(cart.item[i].product_combo_items[z].qty))
            }
          }
        }
        if (cart.item[i].materials.length > 0) {
          for (let c = 0; c < cart.item[i].materials.length; c++) {
            const material = cart.item[i].materials[c]
            if (material.material_product_id && Number(material.material_product_id) === Number(id)) {
              qty = qty + (isEdit ? idx === i ? 0 : Number(material.qty_in_cart) : Number(material.qty_in_cart))
            }
          }
        }
        if (cart.item[i].addons.length > 0) {
          for (let x = 0; x < cart.item[i].addons.length; x++) {
            const item_addons = cart.item[i].addons[x]
            if (item_addons.product_addon_proudct_id && Number(item_addons.product_addon_proudct_id) === Number(id)) {
              // qty = qty + (Number(item_addons.product_addon_qty) * Number(cart.item[i].qty))
              qty = qty + ((isEdit ? idx === i ? 0 : Number(cart.item[i].qty) : Number(cart.item[i].qty)) * Number(item_addons.product_addon_qty))
            }
          }
        }
      }
    }
  }
  return qty
}
Vue.prototype.$maskMoney = function(value) {
  const s = parseInt(value)
  const digit = store.getters.selectedStore.currency_dec_digit
  const cts = store.getters.selectedStore.currency_thousands_sep
  const cdp = store.getters.selectedStore.currency_dec_point
  const currency_symbol = store.getters.selectedStore.currency_symbol

  const val = (s / 1).toFixed(digit).replace('.', cdp)
  return currency_symbol + ' ' + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, cts)
}
Vue.prototype.$formatDate = function(date, short = false) {
  if (!date) return null
  const [year, month, day] = date.split('-')
  var selectedlocale = getLocale()
  if (selectedlocale === undefined || selectedlocale == null) {
    selectedlocale = process.env.VUE_APP_I18N_LOCALE
  }
  let month_name = ''
  if (selectedlocale === 'id') {
    if (short) {
      if (month === '01') {
        month_name = 'Jan'
      } else if (month === '02') {
        month_name = 'Feb'
      } else if (month === '03') {
        month_name = 'Mar'
      } else if (month === '04') {
        month_name = 'Apr'
      } else if (month === '05') {
        month_name = 'Mei'
      } else if (month === '06') {
        month_name = 'Jun'
      } else if (month === '07') {
        month_name = 'Jul'
      } else if (month === '08') {
        month_name = 'Agu'
      } else if (month === '09') {
        month_name = 'Sep'
      } else if (month === '10') {
        month_name = 'Okt'
      } else if (month === '11') {
        month_name = 'Nov'
      } else {
        month_name = 'Des'
      }
    } else {
      if (month === '01') {
        month_name = 'Januari'
      } else if (month === '02') {
        month_name = 'Februari'
      } else if (month === '03') {
        month_name = 'Maret'
      } else if (month === '04') {
        month_name = 'April'
      } else if (month === '05') {
        month_name = 'Mei'
      } else if (month === '06') {
        month_name = 'Juni'
      } else if (month === '07') {
        month_name = 'Juli'
      } else if (month === '08') {
        month_name = 'Agustus'
      } else if (month === '09') {
        month_name = 'September'
      } else if (month === '10') {
        month_name = 'Oktober'
      } else if (month === '11') {
        month_name = 'November'
      } else {
        month_name = 'Desember'
      }
    }
  } else {
    if (short) {
      if (month === '01') {
        month_name = 'Jan'
      } else if (month === '02') {
        month_name = 'Feb'
      } else if (month === '03') {
        month_name = 'Mar'
      } else if (month === '04') {
        month_name = 'Apr'
      } else if (month === '05') {
        month_name = 'May'
      } else if (month === '06') {
        month_name = 'Jun'
      } else if (month === '07') {
        month_name = 'Jul'
      } else if (month === '08') {
        month_name = 'Aug'
      } else if (month === '09') {
        month_name = 'Sep'
      } else if (month === '10') {
        month_name = 'Oct'
      } else if (month === '11') {
        month_name = 'Nov'
      } else {
        month_name = 'Dec'
      }
    } else {
      if (month === '01') {
        month_name = 'January'
      } else if (month === '02') {
        month_name = 'February'
      } else if (month === '03') {
        month_name = 'March'
      } else if (month === '04') {
        month_name = 'April'
      } else if (month === '05') {
        month_name = 'May'
      } else if (month === '06') {
        month_name = 'June'
      } else if (month === '07') {
        month_name = 'July'
      } else if (month === '08') {
        month_name = 'August'
      } else if (month === '09') {
        month_name = 'September'
      } else if (month === '10') {
        month_name = 'October'
      } else if (month === '11') {
        month_name = 'November'
      } else {
        month_name = 'December'
      }
    }
  }
  return `${day} ${month_name} ${year}`
}
Vue.prototype.$hashLatLon = async function(lat, lon) {
  const text = `${lat},${lon}` // gabungkan jadi string
  const bytes = new TextEncoder().encode(text)
  const hashBuffer = await crypto.subtle.digest('SHA-256', bytes)
  return Array.from(new Uint8Array(hashBuffer))
    .map(b => b.toString(16).padStart(2, '0'))
    .join('')
}
